import { Controller } from "@hotwired/stimulus"

// Deshabilita «Reenviar código» durante `duration` segundos y muestra (m:ss).
export default class extends Controller {
  static targets = ["submit", "countdown"]
  static values = { duration: { type: Number, default: 60 } }

  connect() {
    this.remaining = this.durationValue
    this.renderState()

    this.timer = window.setInterval(() => {
      this.remaining -= 1
      if (this.remaining <= 0) {
        window.clearInterval(this.timer)
        this.timer = null
        this.enableSubmit()
        return
      }
      this.renderState()
    }, 1000)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  renderState() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = `(${this.formatSeconds(this.remaining)})`
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-50", "cursor-not-allowed", "pointer-events-none")
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed", "pointer-events-none")
    }
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = ""
      this.countdownTarget.classList.add("hidden")
    }
  }

  formatSeconds(totalSeconds) {
    const m = Math.floor(totalSeconds / 60)
    const s = totalSeconds % 60
    return `${m}:${String(s).padStart(2, "0")}`
  }
}
